import React, { createContext, useContext, useEffect, useReducer, useState } from 'react'
import { Fragment } from 'react'
import { AuthContext } from '../../../App/App'
import InfiniteScroll from "react-infinite-scroll-component";
import ModalAddEditCustomerServices from './ModalAddEditCustomerServices';
import axios from 'axios';
import swal from 'sweetalert'
import ModalDeleteCustomerServices from './ModalDeleteCustomerServices';
import jwt from 'jwt-decode'
export const CSContext = createContext()

function CustomerServices() {
    const myID = jwt(localStorage.getItem('token-helpdesk-umy')).id
    const { stateAuth, dispatchAuth } = useContext(AuthContext)

    const handleClickAdd = (e) => {
        e.preventDefault();
        dispatchCS({
            type: "MODAL_ADD_EDIT",
            modalAddEdit: {
                status: !stateCS.modalAddEdit.status,
                action: "add"
            }
        })
    }
    const handleClickEdit = (id) => {
        dispatchCS({
            type: "SELECTED",
            selected: id
        })
        dispatchCS({
            type: "MODAL_ADD_EDIT",
            modalAddEdit: {
                status: true,
                action: "edit"
            }
        })
    }
    const handleClickDelete = (id) => {
        dispatchCS({
            type: "SELECTED",
            selected: id
        })
        dispatchCS({
            type: "MODAL_DELETE",
            modalDelete: { status: !stateCS.modalDelete.status }
        })
    }

    const initialCustomerServiceRows = {
        customerServices: [],
        rows: 0,
        firstload: true
    }
    const [customerServiceRows, setcustomerServiceRows] = useState(initialCustomerServiceRows)

    const initialReducer = {
        customerServices: [],
        customerService: null,
        load: null,
        modalAddEdit: { status: false, action: null },
        modalDelete: { status: false },
        selected: null,
        trigger: '',
        temp: null
    }
    const reducer = (state, action) => {
        switch (action.type) {
            case "MESSAGE":
                return {
                    ...state,
                    load: action.load
                }
            case "CUSTOMER_SERVICES":
                return {
                    ...state,
                    customerServices: action.customerServices
                }
            case "INSERTED":
                return {
                    ...state,
                    customerService: action.customerService
                }
            case "MODAL_ADD_EDIT":
                return {
                    ...state,
                    modalAddEdit: action.modalAddEdit
                }
            case "MODAL_DELETE":
                return {
                    ...state,
                    modalDelete: action.modalDelete,
                }
            case "SELECTED":
                return {
                    ...state,
                    selected: action.selected
                }
            case "TRIGGER":
                return {
                    ...state,
                    trigger: action.trigger,
                    temp: action.temp
                }
        }
    }
    const [stateCS, dispatchCS] = useReducer(reducer, initialReducer)

    const fetchMoreData = () => {
        dispatchCS({
            type: "MESSAGE",
            load: "...load data"
        })
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/setting/customer-services/customer-services/${customerServiceRows.rows}`, config)
            .then(res => {
                dispatchCS({
                    type: "MESSAGE",
                    load: null
                })

                let cleanCS = customerServiceRows.customerServices.concat(res.data.data)
                let sameID = {}
                cleanCS = cleanCS.filter(function (currentObject) {
                    if (currentObject.id in sameID) {
                        return true
                    } else {
                        sameID[currentObject.id] = true;
                        return true
                    }
                })

                //sort
                cleanCS = cleanCS.sort((a, b) => a.username.localeCompare(b.username))
                setcustomerServiceRows({
                    ...customerServiceRows,
                    customerServices: cleanCS,
                    rows: customerServiceRows.rows + 15,
                    firstload: false
                })
            })
            .catch(err => {
                dispatchCS({
                    type: "MESSAGE",
                    load: null
                })
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}, try agai leter!`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    };

    //store new customer serveices
    useEffect(() => {
        if (stateCS.customerService != null) {
            setcustomerServiceRows({
                ...customerServiceRows,
                customerServices: customerServiceRows.customerServices.concat(stateCS.customerService).sort((a, b) => a.username.localeCompare(b.username))
            })
            //reset new customer service
            dispatchCS({
                type: "INSERTED",
                customerService: null
            })
        }
    }, [stateCS.customerService])

    //update or delete trigger view
    useEffect(() => {
        if (stateCS.trigger == 'delete-cs') {
            let tempCS = customerServiceRows.customerServices;
            const CSIndex = tempCS.findIndex(cs => cs.id == stateCS.temp.id)
            tempCS.splice(CSIndex, 1)

            //update view
            setcustomerServiceRows({
                ...customerServiceRows,
                customerServices: tempCS
            })
            // reset trigger
            dispatchCS({
                type: "TRIGGER",
                trigger: "",
                temp: null
            })
        } else if (stateCS.trigger == 'update-cs') {
            let tempCS = customerServiceRows.customerServices;
            const CSIndex = tempCS.findIndex(cs => cs.id == stateCS.temp.id)
            tempCS[CSIndex].id = stateCS.temp.id;
            tempCS[CSIndex].username = stateCS.temp.username;
            tempCS[CSIndex].displayname = stateCS.temp.displayname;
            tempCS[CSIndex].email = stateCS.temp.email;
            tempCS[CSIndex].role.id = stateCS.temp.role.id;
            tempCS[CSIndex].role.name = stateCS.temp.role.name;

            //update
            setcustomerServiceRows({
                ...customerServiceRows,
                customerServices: tempCS
            })
            // reset trigger
            dispatchCS({
                type: "TRIGGER",
                trigger: "",
                temp: null
            })
        }
    }, [stateCS.trigger])

    const initialState = (
        <Fragment>
            <div className="card-body">
                <div className="empty-state mb-5 pb-5">
                    <div className="empty-state-icon">
                        <i className="fas fa-question"></i>
                    </div>
                    <h2>We couldn't find any customer service</h2>
                    <p className="lead">
                        Sorry we can't find any data, to get rid of this message, make at least 1 entry.
                    </p>
                    <p onClick={handleClickAdd} value="add" style={{ color: '#fff', textTransform: 'capitalize', borderRadius: '30px' }} className="btn  btn-lg btn-icon icon-left btn-success float-right"><i className="fas fa-user-plus"></i> Add New Contact</p>
                </div>
            </div>
        </Fragment>
    )
    const [renderCustomerService, setRenderCustomerService] = useState(initialState)


    useEffect(() => {
        if (customerServiceRows.customerServices.length > 0) {
            dispatchCS({
                type: "CUSTOMER_SERVICES",
                customerServices: customerServiceRows.customerServices
            })
            setRenderCustomerService(
                <Fragment>
                    <div className="card-body p-0">
                        <div className="list-group">
                            <div className="ml-3 mr-3">
                                <div className="d-flex w-100 justify-content-between">
                                    <div className="col-1" style={{ fontWeight: 'bolder', fontSize: '20px', }}>No.</div>
                                    <div className="col-3 pl-4" style={{ fontWeight: 'bolder', fontSize: '20px', }}>Username</div>
                                    <div className="col-4 pl-4" style={{ fontWeight: 'bolder', fontSize: '20px' }}>Email</div>
                                    <div className="col-2" style={{ fontWeight: 'bolder', fontSize: '20px', textAlign: 'center' }}>Role</div>
                                    <div className="col-2" style={{ fontWeight: 'bolder', fontSize: '20px', textAlign: 'center' }}>Action</div>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                    <div id="scrollableDiv" style={{ height: '570px', overflow: "auto" }}>
                        <div className="card-body p-0">
                            <div className="list-group">
                                <InfiniteScroll
                                    dataLength={customerServiceRows.customerServices.length}
                                    next={fetchMoreData}
                                    hasMore={true}
                                    loader={<h4>{stateCS.load}</h4>}
                                    scrollableTarget="scrollableDiv"
                                >
                                    {customerServiceRows.customerServices.map((cus, index) =>
                                    (
                                        <div key={cus.id} className="ml-3 mr-0">
                                            <div className="list-group-item list-group-item-action flex-column align-contacts-start" style={{ borderTop: '0' }}>
                                                <div className="d-flex w-100 justify-content-between">
                                                    <div className="col-1" style={{ fontSize: '17px', }}>
                                                        {index + 1}
                                                    </div>
                                                    <div className="col-3" style={{ fontSize: '17px', }}>
                                                        {cus.username}
                                                    </div>
                                                    <div className="col-4" style={{ fontSize: '17px' }}>
                                                        {cus.email}
                                                    </div>
                                                    <div className="col-2" style={{ fontSize: '17px', textAlign: 'center' }}>
                                                        {cus.role.name}
                                                    </div>
                                                    <div className="col-2 ml-3" style={{ fontSize: '17px', textAlign: 'center' }}>
                                                        <div className="buttons">
                                                            <button style={{ color: '#fff', textTransform: 'capitalize' }} className="btn  btn-sm btn-icon icon-left btn-primary" onClick={handleClickEdit.bind(this, cus.id)} ><i className="fas fa-edit"></i> Edit</button>
                                                            <button style={{ color: '#fff', textTransform: 'capitalize' }} className="btn  btn-sm btn-icon icon-left btn-danger" disabled={cus.id == myID} onClick={handleClickDelete.bind(this, cus.id)} ><i className="fas fa-eraser"></i> Delete</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </InfiniteScroll>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        } else if (customerServiceRows.customerServices.length <= 0) {
            setRenderCustomerService(initialState);

            if (customerServiceRows.firstload == true) {
                fetchMoreData()
            }
        }
    }, [customerServiceRows, stateCS.trigger])
    return (
        <Fragment>
            <div className="col-12 col-md-12 col-lg-12" >
                <div className="card" style={{ minHeight: '83vh' }}>
                    <div className="card-body">
                        <div className="section-title mt-0 pb-4">
                            {stateAuth.page}
                            {(customerServiceRows.customerServices.length > 0 ? (<p onClick={handleClickAdd} value="add" style={{ color: '#fff', textTransform: 'capitalize', borderRadius: '30px' }} className="btn  btn-lg btn-icon icon-left btn-success float-right"><i className="fas fa-user-plus"></i> Add New Customer Service</p>) : '')}
                        </div>
                        {renderCustomerService}
                    </div>
                </div>
            </div>

            <CSContext.Provider value={{ stateCS, dispatchCS }}>
                <ModalAddEditCustomerServices />
                <ModalDeleteCustomerServices />
            </CSContext.Provider>
        </Fragment>
    )
}

export default CustomerServices
